<template>
    <div class="app v-box">
        <z-progress />
        <z-bubble />
        <z-header />
        <z-master-slave />
        <div
            v-if="false"
            ref="logincontainer"
            class="logincontainer"
        />
    </div>
</template>

<script>
import config from '@/utils/config';
import {EventBus} from '@/utils/eventBus';
import IFrame from '@/components/IFrame.vue';

export default {
    name: 'z-app',
    components: {
        IFrame
    },
    data() {
        return {
            code: null,
            intervalRelease: null,
            intervalEnv: null,
            loginpage: null
        };
    },

    created() {
        const url = new URL(window.location.href);
        this.code = url.searchParams.get('code');
        EventBus.on('releasecheck', () => {
            console.log("fetching releases")
            this.$store.dispatch('fetchReleases');
            this.intervalRelease && clearInterval(this.intervalRelease);
            this.intervalRelease = setInterval(() => {
                this.$store.dispatch('fetchReleases');
            }, 120000); //2min
        });
    },

    mounted() {
        if (this.code) {
            this.getTokens().then(() => {
                this.retrieveData();
            }).catch(() => {
                this.redirectToLogin();
            });
            //
        } else {
            this.redirectToLogin();
        }
    },

    methods: {

        retrieveData() {
            EventBus.emit('releasecheck');
            EventBus.emit('envcheck');
        },
        async getTokens() {
            return await this.$store.dispatch('getTokens');
        },

        redirectToLogin() {
            //console.log('window', window);
            window.location.replace(config.loginURL);
        },

        openLogin() {
          //console.log(config.loginURL);
          const iframeApp = createApp(IFrame, {
            source: config.loginURL //'http://localhost:8086/?code=9a18a359-f99d-4f17-bd70-21cde513f1ee'
          });

          const el = document.createElement('div');
          this.$refs.logincontainer.appendChild(el);

          iframeApp.mount(el);
        }
    }
};
</script>

<style lang="scss">

@import 'assets/framework';

.app {
    height: 100vh;
    width: 100vw;
}

.logincontainer {
    width: 100vw;
    height: 100vh;
    position: fixed;
    z-index: 9999;
    background: rgba(0,0,0,0.1);
    iframe {
        width: 100vw;
        height: 100vh;
    }
}
</style>
